// Timeline helpers for the Gantt planner.

// Build an array of month buckets between two dates (inclusive).
export function buildMonths(startDate, endDate) {
  const months = [];
  const d = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
  const end = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
  while (d <= end) {
    months.push(new Date(d));
    d.setMonth(d.getMonth() + 1);
  }
  return months;
}

// Position a bar (left% + width%) on a month timeline.
export function barPosition(start, end, timelineStart, timelineEnd) {
  const total = timelineEnd.getTime() - timelineStart.getTime();
  const left = ((start.getTime() - timelineStart.getTime()) / total) * 100;
  const width = ((end.getTime() - start.getTime()) / total) * 100;
  return {
    left: Math.max(0, left),
    width: Math.max(1.5, Math.min(width, 100 - Math.max(0, left))),
  };
}

export function monthLabel(d) {
  return d.toLocaleDateString("en-US", { month: "short" });
}

export function shortDate(d) {
  return d.toLocaleDateString("en-US", { month: "short", year: "2-digit" });
}

// Given a set of jobs active in a window, total the roles needed by type.
export function aggregateRoleDemand(jobs) {
  const demand = {};
  jobs.forEach((j) => {
    (j.RolesNeeded || []).forEach((r) => {
      demand[r] = (demand[r] || 0) + 1;
    });
  });
  return demand;
}

// Do two date ranges overlap?
export function overlaps(aStart, aEnd, bStart, bEnd) {
  return aStart <= bEnd && bStart <= aEnd;
}

// Confidence → band color
export function confidenceColor(pct) {
  if (pct >= 75) return "var(--green-bar)";
  if (pct >= 50) return "var(--gold)";
  return "var(--red-bar)";
}
